(function(doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function() {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return
      //这里是为了大屏显示更好看点，所以把最大字体控制到16px
      if (clientWidth >= 1000) {
        docEl.style.fontSize = 16 * (clientWidth / 1200) + 'px'
      } else {
        docEl.style.fontSize = 16 * (clientWidth / 375) + 'px'
      }
    }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)



// WEBPACK FOOTER //
// ./src/util/rem.js